export default __webpack_public_path__ + "static/media/tgame.d0bb2afe.png";